/**
 * Created by Andrew on 01/03/2017.
 */

import React, { Component } from "react";
import CreateCluster from "../presentation/CreateCluster";
import validator from "validator";

class CreateClusterWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      devices: [],
      cluster: [],
      selectedDevices: [],
      clusterDevice: [],
      clusterName: "",
      clusterComments: "",
      errorField: "",
      success: "",
      error: "",
      search: "",
      sort: "name",
      sortAsc: "true",
      sortDevices: "name",
      sortDevicesAsc: "true",
      currentCluster: ""
    };
  }

  componentDidMount() {
    this.getDeviceList();
  }

  updateFormState = e => {
    let obj = {};
    obj[e.target.name] = e.target.value;
    this.setState(obj);
  };

  validateInput = () => {
    if (this.state.clusterName === "") {
      this.setState({
        error: "Please enter a cluster name",
        errorField: "clusterName"
      });
    } else if (!this.state.selectedDevices.length) {
      this.setState({
        error: "Please select at least one device",
        errorField: "selectedDevices"
      });
    } else {
      this.setState({ error: false });
      return true;
    }
  };

  handleSubmit = () => {
    let selectedDevices = this.state.selectedDevices;
    let devices = selectedDevices.map(selectedDevice => selectedDevice._id);

    const body = {
      name: this.state.clusterName,
      comments: this.state.clusterComments,
      devices: devices
    };

    this.setState({ serverError: "", success: "" });

    if (this.validateInput()) {
      fetch("/service/createCluster", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify(body)
      }).then(response => {
        if (response.status !== 200) {
          response.json().then(json => {
            this.setState({ serverError: "Error saving cluster" });
          });
        } else {
          response.json().then(json => {
            this.props.navigator.requestClusterManagement();
          });
        }
      });
    }
  };

  getClusterDevices = () => {
    const getClusterDevicesUrl =
      "/service/getClusterDevices" +
      "?devices=" +
      this.state.clusterDevices +
      "&sortDevices=" +
      this.state.sortDevices +
      "&sortDevicesAsc=" +
      this.state.sortDevicesAsc;

    fetch(getClusterDevicesUrl, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).then(response => {
      if (response.status === 200) {
        response.json().then(selectedDevices => {
          this.setState({ selectedDevices }, () => {
            this.getDeviceList();
          });
        });
      }
    });
  };

  getDeviceList = () => {
    const getDevicesUrl =
      "/service/devices" +
      "?search=" +
      this.state.search +
      "&sort=" +
      this.state.sort +
      "&sortAsc=" +
      this.state.sortAsc +
      "&registeredOnly=" +
      "true";

    this.setState({ isLoading: true }, () => {
      fetch(getDevicesUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }).then(response => {
        if (response.status !== 200) {
          this.setState({ isLoading: false });
        } else {
          response.json().then(devices => {
            let selectedDevices = JSON.parse(
              JSON.stringify(this.state.selectedDevices)
            ); //Deep copy

            if (selectedDevices.length) {
              let result = "";

              selectedDevices.map(selectedDevice => {
                result = devices.find(
                  device => device._id === selectedDevice._id
                );

                if (result) {
                  devices.splice(devices.indexOf(result), 1);
                }
              });
            }

            this.setState({ devices, isLoading: false });
          });
        }
      });
    });
  };

  updateClusterDevice = deviceId => {
    this.setState(prevState => {
      let { devices, selectedDevices } = { ...prevState };
      devices = devices.filter(device => {
        if (device._id === deviceId) {
          selectedDevices.push(device);
          return false;
        } else {
          return true;
        }
      });

      return { selectedDevices, devices };
    });
  };

  removeDevice = deviceId => {
    this.setState(prevState => {
      let { devices, selectedDevices } = { ...prevState };
      selectedDevices = selectedDevices.filter(selectedDevice => {
        if (selectedDevice._id === deviceId) {
          devices.push(selectedDevice);
          return false;
        } else {
          return true;
        }
      });

      return { selectedDevices, devices };
    });
  };

  updateSearchState = e => {
    this.setState({ search: e.target.value }, () => {
      this.getDeviceList();
    });
  };

  updateSortState = sortBy => {
    const callback = () => this.getDeviceList();
    if (sortBy === this.state.sort) {
      this.setState(prevState => ({ sortAsc: !prevState.sortAsc }), callback);
    } else {
      this.setState({ sort: sortBy }, callback);
    }
  };

  updateDevicesSortState = sortBy => {
    const callback = () =>
      this.getClusterDevices(this.state.currentCluster, false);
    if (sortBy === this.state.sortDevices) {
      this.setState(
        prevState => ({ sortDevicesAsc: !prevState.sortDevicesAsc }),
        callback
      );
    } else {
      this.setState({ sortDevices: sortBy }, callback);
    }
  };

  render() {
    return (
      <CreateCluster
        navigator={this.props.navigator}
        handleSubmit={this.handleSubmit}
        updateFormState={this.updateFormState}
        loadData={this.state}
        updateClusterDevice={this.updateClusterDevice}
        removeDevice={this.removeDevice}
        updateSearchState={this.updateSearchState}
        updateSortState={this.updateSortState}
        updateDevicesSortState={this.updateDevicesSortState}
      />
    );
  }
}

export default CreateClusterWidget;
